/**
 * YouTube Gallery Block JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
    // Initialize YouTube galleries
    const youtubeGalleries = document.querySelectorAll('.youtube-gallery-block');
    
    youtubeGalleries.forEach(gallery => {
        const layout = gallery.dataset.layout;
        const lazyLoad = gallery.dataset.lazyLoad === 'true';
        const lightbox = gallery.dataset.lightbox === 'true';
        
        // Initialize lazy loading
        if (lazyLoad) {
            initLazyLoading(gallery);
        }
        
        // Initialize slider if layout is slider
        if (layout === 'slider') {
            initYouTubeSlider(gallery);
        }
        
        // Initialize video interactions
        initVideoInteractions(gallery, lightbox);
    });
});

// Initialize Slick slider for YouTube gallery
function initYouTubeSlider(gallery) {
    const slider = gallery.querySelector('.youtube-gallery-slider');
    
    if (!slider || typeof $ === 'undefined' || typeof $.fn.slick === 'undefined') {
        console.warn('Slick slider not available for YouTube gallery');
        return;
    }
    
    // Get options from data attributes
    const slidesToShow = parseInt(gallery.dataset.slidesToShow) || 3;
    const autoplay = gallery.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(gallery.dataset.autoplaySpeed) || 4000;
    const infinite = gallery.dataset.infinite === 'true';
    const arrows = gallery.dataset.arrows === 'true';
    const dots = gallery.dataset.dots === 'true';
    
    // Initialize Slick slider
    $(slider).slick({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        infinite: infinite,
        arrows: arrows,
        dots: dots,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(slidesToShow, 2),
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ],
        // Accessibility improvements
        accessibility: true,
        focusOnSelect: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        useTransform: true,
        cssEase: 'ease',
        speed: 300
    });
    
    // Custom arrow styling
    if (arrows) {
        const prevArrow = slider.parentElement.querySelector('.slick-prev');
        const nextArrow = slider.parentElement.querySelector('.slick-next');
        
        if (prevArrow) {
            prevArrow.innerHTML = '<span aria-hidden="true">←</span><span class="sr-only">Previous videos</span>';
        }
        
        if (nextArrow) {
            nextArrow.innerHTML = '<span aria-hidden="true">→</span><span class="sr-only">Next videos</span>';
        }
    }
    
    // Pause autoplay when page is not visible
    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            $(slider).slick('slickPause');
        } else if (autoplay) {
            $(slider).slick('slickPlay');
        }
    });
}

// Initialize lazy loading for video thumbnails
function initLazyLoading(gallery) {
    const lazyImages = gallery.querySelectorAll('img.lazy');
    
    if (lazyImages.length === 0) return;
    
    // Use Intersection Observer for lazy loading
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    const src = img.dataset.src;
                    
                    if (src) {
                        img.src = src;
                        img.classList.remove('lazy');
                        img.classList.add('loaded');
                        
                        // Handle load errors
                        img.onerror = function() {
                            // Fallback to standard resolution thumbnail
                            const videoId = extractVideoIdFromThumbnail(src);
                            if (videoId) {
                                img.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                            }
                        };
                        
                        observer.unobserve(img);
                    }
                }
            });
        }, {
            rootMargin: '50px 0px',
            threshold: 0.01
        });
        
        lazyImages.forEach(img => imageObserver.observe(img));
    } else {
        // Fallback for browsers without Intersection Observer
        lazyImages.forEach(img => {
            const src = img.dataset.src;
            if (src) {
                img.src = src;
                img.classList.remove('lazy');
                img.classList.add('loaded');
            }
        });
    }
}

// Initialize video interactions (play, lightbox, embed)
function initVideoInteractions(gallery, lightboxMode) {
    const videoLinks = gallery.querySelectorAll('.video-link');
    
    videoLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const videoId = this.dataset.videoId;
            
            if (!videoId) return;
            
            if (lightboxMode) {
                openVideoLightbox(videoId, this.dataset.title || '');
            } else {
                const embedTarget = this.dataset.embedTarget;
                if (embedTarget) {
                    embedVideo(embedTarget, videoId);
                }
            }
        });
        
        // Keyboard support
        link.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
    });
}

// Embed YouTube video in container
function embedVideo(containerId, videoId) {
    const container = document.getElementById(containerId);
    
    if (!container) return;
    
    // Show container
    container.style.display = 'block';
    
    // Create iframe
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
    iframe.title = 'YouTube video player';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    
    // Clear container and add iframe
    container.innerHTML = '';
    container.appendChild(iframe);
    
    // Add close button
    const closeButton = document.createElement('button');
    closeButton.className = 'video-close-btn';
    closeButton.innerHTML = '✕';
    closeButton.title = 'Close video';
    closeButton.addEventListener('click', function() {
        container.style.display = 'none';
        container.innerHTML = '';
    });
    
    container.appendChild(closeButton);
    
    // Close on Escape key
    document.addEventListener('keydown', function escapeHandler(e) {
        if (e.key === 'Escape') {
            closeButton.click();
            document.removeEventListener('keydown', escapeHandler);
        }
    });
}

// Open video in lightbox/modal
function openVideoLightbox(videoId, title) {
    // Create lightbox overlay
    const lightbox = document.createElement('div');
    lightbox.className = 'youtube-lightbox-overlay';
    lightbox.innerHTML = `
        <div class="youtube-lightbox-container">
            <div class="youtube-lightbox-header">
                <h3 class="youtube-lightbox-title">${escapeHtml(title)}</h3>
                <button class="youtube-lightbox-close" aria-label="Close video">✕</button>
            </div>
            <div class="youtube-lightbox-content">
                <iframe 
                    src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                </iframe>
            </div>
        </div>
    `;
    
    // Add lightbox styles - Black background, full screen
    lightbox.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.95);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        opacity: 0;
        transition: opacity 0.3s ease;
    `;
    
    const container = lightbox.querySelector('.youtube-lightbox-container');
    container.style.cssText = `
        background: #000000;
        border-radius: 0;
        overflow: hidden;
        width: 95vw;
        height: 95vh;
        max-width: none;
        max-height: none;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
        transform: scale(0.9);
        transition: transform 0.3s ease;
        display: flex;
        flex-direction: column;
    `;
    
    const header = lightbox.querySelector('.youtube-lightbox-header');
    header.style.cssText = `
        padding: 1rem 1.5rem;
        background: #000000;
        border-bottom: 1px solid #333333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;
    `;
    
    const titleElement = lightbox.querySelector('.youtube-lightbox-title');
    titleElement.style.cssText = `
        color: #ffffff;
        margin: 0;
        font-size: 1.1rem;
    `;
    
    const content = lightbox.querySelector('.youtube-lightbox-content');
    content.style.cssText = `
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #000000;
    `;
    
    const iframe = lightbox.querySelector('iframe');
    iframe.style.cssText = `
        width: 100%;
        height: 100%;
        border: none;
        max-width: 100%;
        max-height: 100%;
    `;
    
    const closeBtn = lightbox.querySelector('.youtube-lightbox-close');
    closeBtn.style.cssText = `
        background: none;
        border: none;
        font-size: 1.8rem;
        cursor: pointer;
        padding: 0.5rem;
        border-radius: 4px;
        transition: background-color 0.2s ease;
        color: #ffffff;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    `;
    
    // Add to page
    document.body.appendChild(lightbox);
    document.body.style.overflow = 'hidden';
    
    // Animate in
    requestAnimationFrame(() => {
        lightbox.style.opacity = '1';
        container.style.transform = 'scale(1)';
    });
    
    // Close handlers
    function closeLightbox() {
        lightbox.style.opacity = '0';
        container.style.transform = 'scale(0.9)';
        
        setTimeout(() => {
            document.body.removeChild(lightbox);
            document.body.style.overflow = '';
        }, 300);
    }
    
    closeBtn.addEventListener('click', closeLightbox);
    
    lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox) {
            closeLightbox();
        }
    });
    
    document.addEventListener('keydown', function escapeHandler(e) {
        if (e.key === 'Escape') {
            closeLightbox();
            document.removeEventListener('keydown', escapeHandler);
        }
    });
}

// Utility functions
function extractVideoIdFromThumbnail(thumbnailUrl) {
    const match = thumbnailUrl.match(/\/vi\/([^\/]+)\//);
    return match ? match[1] : null;
}

function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

// Add CSS for video close button and lightbox
const style = document.createElement('style');
style.textContent = `
    .video-close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        border: none;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        cursor: pointer;
        font-size: 14px;
        line-height: 1;
        z-index: 10;
        transition: background-color 0.2s ease;
    }
    
    .video-close-btn:hover {
        background: rgba(0, 0, 0, 0.9);
    }
    
    .youtube-lightbox-close:hover {
        background-color: #e9ecef;
    }
    
    @media (max-width: 768px) {
        .youtube-lightbox-content {
            width: 95vw !important;
        }
        
        .youtube-lightbox-header {
            padding: 0.75rem 1rem !important;
        }
        
        .youtube-lightbox-title {
            font-size: 1rem;
            margin: 0;
        }
    }
`;
document.head.appendChild(style);